<script lang="ts" setup>
import SchoolPicker from '~components/admin/SchoolPicker.vue'

withDefaults(defineProps<{
  schoolId?: number | null
  sendEmail: boolean
}>(), {
  schoolId: null,
})

// const emit = defineEmits<{
//   'update:schoolId': [value: number | null]
//   'update:sendEmail': [value: boolean]
// }>()
const emit = defineEmits(['update:schoolId', 'update:sendEmail']) // typed version of defineEmits doesn't work in 2.7

function onSchoolInput(schoolId: number | null) {
  emit('update:schoolId', schoolId)
}

function onEmailToggle(event: Event) {
  const target = event.target as HTMLInputElement
  emit('update:sendEmail', target.checked)
}
</script>

<template>
  <div class="bulk-options">
    <div class="form-group">
      <label for="default-school">Default School</label>
      <SchoolPicker
        id="default-school"
        :value="schoolId"
        @input="onSchoolInput"
      />
    </div>

    <div class="form-check mt-2">
      <input
        type="checkbox"
        class="form-check-input"
        :checked="sendEmail"
        @change="onEmailToggle"
      />
      <label class="form-check-label">
        Send welcome email to new users (contacts excluded)
      </label>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bulk-options {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
  margin: 1rem 0;
}
</style>
